import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../css/Form.css';

const Register = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    email: '',
    dateOfBirth: '',
    phone: '',
    countryCode: '+1', // Default country code
  });
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    // Validate phone number (10 digits check)
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(formData.phone)) {
      setError('Phone number must be 10 digits.');
      return;
    }

    // Concatenate country code and phone number
    const fullPhoneNumber = formData.countryCode + formData.phone;

    try {
      // Include the concatenated phone number in the form data
      const updatedFormData = { ...formData, phone: fullPhoneNumber };

      // Make an axios POST request to http://localhost:8081/api/auth/register
      await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/register`, updatedFormData);
      setSuccessMessage('Registration successful! Please enter OTP to verify.');

      // Navigate to a new page for OTP verification 
      navigate('/otp-verification', { state: { email: formData.email } }); 
    } catch (error) {
      console.error('Registration error:', error);
      setError('Registration failed! Please try again.');
    }
  };

  return (
    <div className="form-container">
      <div className="form-wrapper">
        <h2>Register</h2>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="text"
              name="username"
              placeholder="Username"
              onChange={handleChange}
              value={formData.username}
              required
            />
          </div>
          <div className="input-group">
            <input
              type="email"
              name="email"
              placeholder="Email"
              onChange={handleChange}
              value={formData.email}
              required
            />
          </div>
          <div className="input-group">
            <input
              type="password"
              name="password"
              placeholder="Password"
              onChange={handleChange}
              value={formData.password}
              required
            />
          </div>
          <div className="input-group">
            <label htmlFor="dateOfBirth">Date of Birth</label>
            <input
              type="date"
              name="dateOfBirth"
              onChange={handleChange}
              value={formData.dateOfBirth}
              required
            />
          </div>
          <div className="input-group">
            <select
              name="countryCode"
              value={formData.countryCode}
              onChange={handleChange}
              required
            >
              <option value="+1">+1 (USA/Canada)</option>
              <option value="+44">+44 (UK)</option>
              <option value="+91">+91 (India)</option>
              <option value="+61">+61 (Australia)</option>
              {/* Add more country codes as needed */}
            </select>
            <input
              type="text"
              name="phone"
              placeholder="Phone (10 digits)"
              onChange={handleChange}
              value={formData.phone}
              required
              maxLength={10} // Enforce 10 digits length
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          {successMessage && <div className="success-message">{successMessage}</div>}
          <button type="submit" className="submit-btn">Register</button>
        </form>
        <p>
          Already have an account? <a href="/login">Login here</a>
        </p>
      </div>
    </div>
  );
};

export default Register;